import Phaser from 'phaser';
import ErrorHandler from './scenes/modules/ErrorHandler.js';
import { createMapScene } from './scenes/dynamic_map_scene.js';

// 导入游戏场景
import BootScene from './scenes/boot.js';
import PreloaderScene from './scenes/preloader.js';
import TitleScene from './scenes/title.js';
import CharacterSelectScene from './scenes/character_select.js';
import LoginScene from './scenes/login.js';
import MenuScene from './scenes/menu.js';
import BattleScene from './scenes/battle.js';
import ShopScene from './scenes/shop.js';
import MultiplayerScene from './scenes/multiplayer.js';
import VehicleEquipmentScene from './scenes/vehicle_equipment_scene.js';
import LotteryScene from './scenes/lottery_scene.js';
import BlueprintLotteryScene from './scenes/blueprint_lottery_scene.js';
import { MAP_SCENE_CONFIG } from './scenes/modules/SceneRegistry.js';

// 动态创建所有地图场景
const mapScenes = Object.entries(MAP_SCENE_CONFIG).map(([sceneKey, mapKey]) => {
    return createMapScene(sceneKey, mapKey);
});

// 游戏配置
const config = {
    type: Phaser.AUTO,
    width: window.innerWidth,
    height: window.innerHeight,
    parent: 'game-container',
    pixelArt: true,
    roundPixels: true,
    scene: [
        BootScene, 
        PreloaderScene,
        LoginScene,  // 登录场景移到最前面
        TitleScene, 
        CharacterSelectScene,
        ...mapScenes,  // 展开所有动态创建的场景（包括WorldScene）
        MenuScene, 
        BattleScene, 
        ShopScene, 
        MultiplayerScene,
        VehicleEquipmentScene,
        LotteryScene,
        BlueprintLotteryScene
    ],
    scale: {
        mode: Phaser.Scale.FIT,  // 使用FIT模式，保持宽高比
        autoCenter: Phaser.Scale.CENTER_BOTH,
        orientation: Phaser.Scale.LANDSCAPE,  // 强制横屏
        width: window.innerWidth,
        height: window.innerHeight
    },
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 },
            debug: false
        }
    },
    audio: {
        disableWebAudio: false,
        noAudio: false
    },
    input: {
        keyboard: true,  // 启用键盘输入
        mouse: true,     // 启用鼠标输入
        touch: true      // 启用触摸输入
    }
};

// 游戏状态将在BootScene中初始化
// 这里不进行任何初始化操作

// 创建游戏实例
let game;
try {
    game = new Phaser.Game(config);
} catch (error) {
    ErrorHandler.handleError(error, '游戏初始化');
    // 显示错误提示
    const container = document.getElementById('game-container');
    if (container) {
        container.innerHTML = `
            <div style="text-align: center; padding: 50px; color: #ff0000;">
                <h2>游戏初始化失败</h2>
                <p>${ErrorHandler.getUserFriendlyMessage(error.message, '游戏初始化')}</p>
                <p>请刷新页面重试</p>
            </div>
        `;
    }
}


window.addEventListener('resize', () => {
    if (game && game.scale) {
        game.scale.resize(window.innerWidth, window.innerHeight);
    }
});

// 全局错误捕获
window.onerror = function (message, source, lineno, colno, error) {
    try {
        ErrorHandler.handleError(
            error || new Error(message),
            `全局错误 (${source}:${lineno}:${colno})`
        );
    } catch (e) {
        console.error('错误处理器本身出错:', e);
    }
    return true; // 阻止默认错误处理
};

// Promise rejection 错误捕获
window.addEventListener('unhandledrejection', (event) => {
    try {
        ErrorHandler.handleError(
            event.reason || new Error('未处理的Promise拒绝'),
            '异步操作'
        );
    } catch (e) {
        console.error('错误处理器本身出错:', e);
    }
});

// 老四机兵初始化完成

export { game };